/** Session flag: Schulgemeinde path from `/welcome` — plan → license → success → authority profile. */
export const AUTHORITY_NEW_FLOW_KEY = 'bn_authority_new_flow_v1';

export function setAuthorityNewFlowFlag(): void {
  sessionStorage.setItem(AUTHORITY_NEW_FLOW_KEY, '1');
}

export function isAuthorityNewFlow(): boolean {
  return sessionStorage.getItem(AUTHORITY_NEW_FLOW_KEY) === '1';
}

export function clearAuthorityNewFlowFlag(): void {
  sessionStorage.removeItem(AUTHORITY_NEW_FLOW_KEY);
}
